import { OrgRoleFilterFragment } from '../graphql/fragment/generated/OrgRoleFilter';

export const getOrgRoleFilterOption = (role: OrgRoleFilterFragment) => ({
  value: role.id,
  label: role.name,
});
